import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import DjangoMessages from 'components/DjangoMessages';
import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

type DocumentItem = {
    code: string;
    displayName: string;
};

export type DocumentConversionSettingsBackend = Backend<{
    entries: Array<DocumentItem>;
}>;

const DocumentConversionSettingsRoot: FC = () => {
    const {data} = useBackend<DocumentConversionSettingsBackend>();

    const {t} = useTranslation('Document.ConversionSettings.Root');

    return (
        <div>
            <DjangoMessages className="mb-2" />
            <NavigationTabs.DocumentSettings selection="conversionSettings" />
            <SectionHeader subtitle={t('subtitle')} title={t('title')} />
            <div className="mt-4 grid grid-cols-2 gap-4">
                {data.entries.map(({code, displayName}) => (
                    <LinkButton
                        key={displayName}
                        className={[
                            'w-full border-grey-400 text-green-800',
                            'hover:border-transparent hover:bg-grey-900/10',
                            'active:border-green-600 active:bg-green-100 active:text-green-900',
                        ].join(' ')}
                        href={window.Urls.documentconversionsettings_by_type_react_view(
                            code,
                        )}
                        icon="document"
                        kind="custom"
                    >
                        {displayName}
                    </LinkButton>
                ))}
            </div>
        </div>
    );
};

export default DocumentConversionSettingsRoot;
